import React, { Component, PropTypes } from 'react';
import { Link, browserHistory } from 'react-router';

class MainMenu extends Component {

  constructor(props) {
    super(props)
  }

  renderLink(staticVersion, primaryMenuItem, secondaryMenuItem) {
    return (staticVersion) ? <a href={ staticVersion == true ? '#' + primaryMenuItem.toLowerCase().replace(" ", "-") + '/' + secondaryMenuItem.anchor.replace('#', '') : primaryMenuItem.toLowerCase().replace(" ", "-") + secondaryMenuItem.anchor}>{secondaryMenuItem.name}</a> : <Link to={ staticVersion == true ? '#' + primaryMenuItem.toLowerCase().replace(" ", "-") + '/' + secondaryMenuItem.anchor.replace('#', '') : primaryMenuItem.toLowerCase().replace(" ", "-") + secondaryMenuItem.anchor}>{secondaryMenuItem.name}</Link>;
  }

  renderMenu(menuItems, selected, staticVersion) {
    const _this = this;
    return (<ul className="nav__items--primary">
      {Object.keys(menuItems).map(function(primaryMenuItem, i) {
        return (
          <li key={primaryMenuItem + "__" + i} className={"nav__item--primary has-children " + (primaryMenuItem === selected ? "is-active" : "")}>
            <a>{primaryMenuItem}</a>
            <ul className="nav__items--secondary">
            {menuItems[primaryMenuItem].map(function(secondaryMenuItem, j) {
              if (staticVersion === false || secondaryMenuItem.includeStatic !== false) {
                return ( <li key={primaryMenuItem + "__" + secondaryMenuItem.name} className="nav__item--secondary">
                  {_this.renderLink(staticVersion, primaryMenuItem, secondaryMenuItem)}
		            </li>)
              }
            })}
            </ul>
          </li>
        )
      })}
      </ul>
    )
  }

  render (){
    const { selected, staticVersion, components } = this.props;
    return(
      <nav className="nav nav--dark nav--global fixed drop-shadow js-nav">
        <div className="nav__inner">
          <div className="nav__header">
            <a className="nav__logo" href="//www.cmegroup.com" rel="external" target="_blank" title="CME Group"></a>
            <h1 className="nav__app-name">Common UI</h1>
          </div>
          {this.renderMenu(components, selected, staticVersion)}
          <ul className="nav__actions">
            <li className="nav__action"><small>v1.28.0.6</small></li>
          </ul>
        </div>
      </nav>
    )
  }
}

export default MainMenu



// WEBPACK FOOTER //
// ./styleguide/components/MainMenu.js